import "date-fns";
import React from "react";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { format, parse } from "date-fns";
import MaterialSymbol from "components/MaterialSymbol/MaterialSymbol";

let calendarPickerIdSequence = 0;

export default function MaterialUIPickers({
    label = "",
    date,
    setDate,
    id,
    inputFormat = "MM/dd/yyyy",
    outputFormat = "MM/dd/yyyy",
    ...otherProps
}) {
    const defaultDate = date ? parse(date, outputFormat, new Date()) : null;
    const generatedIdRef = React.useRef("");

    if (!generatedIdRef.current) {
        calendarPickerIdSequence += 1;
        generatedIdRef.current = id || `calendar-picker-${calendarPickerIdSequence}`;
    }

    const handleDateChange = (newDate) => {
        if (!newDate) return setDate("");

        const isValid = !isNaN(newDate.getTime());
        if (isValid) {
            const formatted = format(newDate, outputFormat);
            setDate(formatted);
            console.log("Formatted:", formatted);
        }
    };

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
                fullWidth
                variant="inline"
                format={inputFormat}
                margin="normal"
                id={generatedIdRef.current}
                label={label}
                value={defaultDate}
                onChange={handleDateChange}
                KeyboardButtonProps={{
                    "aria-label": "change date",
                }}
                keyboardIcon={<MaterialSymbol>calendar_today</MaterialSymbol>}
                style={{ margin: 0 }}
                autoOk
                {...otherProps}
            />
        </MuiPickersUtilsProvider>
    );
}

/*import React from 'react';
import TextField from '@material-ui/core/TextField';

const CalendarPicker = ({ label = '', date, setDate, ...otherProps }) => {
    const handleDateChange = (event) => {
        setDate(event.target.value);
    };

    return (
        <TextField
            {...otherProps}
            id="date-picker"
            label={label}
            type="date"
            value={date}
            onChange={handleDateChange}
            InputLabelProps={{
                shrink: true,
            }}
        />
    );
};

export default CalendarPicker;*/
